import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { IDataProdutoNF } from "./CardProdutos";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import BtnLoading from "../../../../../../components/BasicComponents/Buttons/BtnLoading";
import { useMemo } from "react";


export default function DialogConfirmRecebimento({
    open,
    onClose,
    onConfirm,
    recebimentos,
    isLoading
}: DialogConfirmRecebimentoProps) {


    const possuiDivergencias = useMemo(() => {
        return !recebimentos.every((p) => p.recebido && p.status === 'Encontrado') || recebimentos.some((p) => Number(p.quantidade_recebida) !== Number(p.nf_quantidade));
    }, [recebimentos]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Confirmar recebimento?</DialogTitle>
            <DialogContent>
                {
                    !possuiDivergencias &&
                    <Typography>O recebimento será registrado para todos os itens dessa nota fiscal</Typography>
                }
                {
                    possuiDivergencias &&
                    <>
                        <Typography>Esse recebimento será registrado e enviado para análise de divergências dos seguintes itens:</Typography>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Produto da NF</b></TableCell>
                                        <TableCell><b>Motivo</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {recebimentos.map((produto: IDataProdutoNF, index: number) => {
                                        let motivo = '';
                                        if (!produto.recebido) motivo = 'Não recebido';
                                        if (produto.status !== 'Encontrado') motivo = 'Produto não encontrado na OC';
                                        if (Number(produto.quantidade_recebida) !== Number(produto.nf_quantidade)) motivo = 'Quantidade recebida diferente da nota fiscal';
                                        return (
                                            <TableRow key={produto.nf_item_id} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell><b>{produto.nf_produto}</b></TableCell>
                                                <TableCell>{motivo}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={onClose} disabled={isLoading}>Cancelar</Button>
                <BtnLoading loading={isLoading} loadingText="Confirmando..." onClick={onConfirm}>Confirmar</BtnLoading>
            </DialogActions>
        </Dialog>

    )
}

interface DialogConfirmRecebimentoProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    recebimentos: IDataProdutoNF[];
    isLoading?: boolean;
}
